/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AWSKinesisCredentials = {
  /**
   * AWS Access Key ID.
   */
  key: string;
  /**
   * AWS Secret Access Key.
   */
  secret: string;
  /**
   * Optional AWS Session Token (for temporary credentials).
   */
  session?: string | undefined;
};

/** @internal */
export const AWSKinesisCredentials$inboundSchema: z.ZodType<
  AWSKinesisCredentials,
  z.ZodTypeDef,
  unknown
> = z.object({
  key: z.string(),
  secret: z.string(),
  session: z.string().optional(),
});
/** @internal */
export type AWSKinesisCredentials$Outbound = {
  key: string;
  secret: string;
  session?: string | undefined;
};

/** @internal */
export const AWSKinesisCredentials$outboundSchema: z.ZodType<
  AWSKinesisCredentials$Outbound,
  z.ZodTypeDef,
  AWSKinesisCredentials
> = z.object({
  key: z.string(),
  secret: z.string(),
  session: z.string().optional(),
});

export function awsKinesisCredentialsToJSON(
  awsKinesisCredentials: AWSKinesisCredentials,
): string {
  return JSON.stringify(
    AWSKinesisCredentials$outboundSchema.parse(awsKinesisCredentials),
  );
}
export function awsKinesisCredentialsFromJSON(
  jsonString: string,
): SafeParseResult<AWSKinesisCredentials, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AWSKinesisCredentials$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AWSKinesisCredentials' from JSON`,
  );
}
